import {
  Avatar,
  styled,
} from "@mui/material";

export const StyledProfilePic = styled(Avatar)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: "2px",
  color: "white",
  flex: "none",
  order: "0",
  flexGrow: "0",
  zIndex: "0",
  borderRadius: "50%",
  backgroundColor: "#393A3B",
  ":hover": {
    transform: "scale(1.1)",
  },
  [theme.breakpoints.up("md")]: {
    width: "2.5vw",
    height: "2.5vw",
  },
  [theme.breakpoints.down("md")]: {
    width: "5vw",
    height: "5vw",
  },
  [theme.breakpoints.down("sm")]: {
    width: "8vw",
    height: "8vw",
  },
}));